import React from "react";
import { Badge, Theme } from "@120wateraudit/waterworks";
import { Popup } from "semantic-ui-react";
import { ExportStatus } from "src/services/export-service-api";

interface ExportStatusBadgeProps {
  status: ExportStatus;
  errors: string[];
  style?: React.CSSProperties;
}

const getExportStatusColors = (
  status: ExportStatus
): { background: string; text: string } => {
  const failedBg = Theme.palette.badgeErrorBackground;
  const failedText = Theme.palette.badgeErrorText;

  const processingBg = Theme.palette.badgeInProgressBackground;
  const processingText = Theme.palette.badgeInProgressText;

  const completedBg = Theme.palette.badgeSuccessBackground;
  const completedText = Theme.palette.badgeSuccessText;

  const inactiveBg = Theme.palette.badgeInactiveBackground;
  const inactiveText = Theme.palette.badgeInactiveText;

  if (status === ExportStatus.Failed) {
    return { background: failedBg, text: failedText };
  } else if (status === ExportStatus.GatheringData) {
    return { background: processingBg, text: processingText };
  } else if (status === ExportStatus.Completed) {
    return { background: completedBg, text: completedText };
  }

  return { background: inactiveBg, text: inactiveText };
};

export const ExportStatusBadge: React.FC<ExportStatusBadgeProps> = ({
  status,
  errors,
  style,
}) => {
  const errorsList = errors?.map((error: string, index: number) => (
    <p key={index}>{error}</p>
  ));
  const { background: statusBackground, text: statusText } = getExportStatusColors(
    status
  );
  const errorDialogContent = <div>{errorsList}</div>;
  const badge = (
    <Badge
      style={{
        ...style,
        justifyContent: "center",
        textAlign: "center",
        minWidth: "80px",
        color: statusText,
      }}
      backgroundColor={statusBackground}
    >
      {status.replace(/([a-z])([A-Z])/g, '$1 $2')}
    </Badge>
  );

  return status === ExportStatus.Failed
  ? (
    <Popup
      trigger={<div>{badge}</div>}
      content={errorDialogContent}
      position="top center"
    />
  )
  : (
    <div>{badge}</div>
  );
};

export default ExportStatusBadge;
